import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import PocketBase from 'pocketbase';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  email = '';
  password = '';
  loading = false;
  error: string | null = null;

  private pb = new PocketBase('https://assets-base.beedev.in.th/');

  constructor(private router: Router) {
    // If already authenticated, redirect to /home
    if (this.pb.authStore.isValid) {
      this.router.navigate(['/home']);
    }
  }

  async login(event: Event) {
    event.preventDefault();
    this.loading = true;
    this.error = null;
    try {
      const authData = await this.pb.collection('users_person').authWithPassword(this.email, this.password);
      await Swal.fire({
        icon: 'success',
        title: 'Login Success',
        text: 'Welcome!',
        timer: 1500,
        showConfirmButton: false
      });
      this.router.navigate(['/home']);
    } catch (err: any) {
      this.error = err?.message || 'Login failed';
      await Swal.fire({
        icon: 'error',
        title: 'Login Failed',
        text: this.error || 'Login failed'
      });
    } finally {
      this.loading = false;
    }
  }
}
